/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_EquipmentInputs */

const en_us2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving your equipment.`)
};

const pt_br2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar seu equipamento.`)
};

const es_419_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar tu equipo.`)
};

const pt_pt2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar o teu equipamento.`)
};

const fr_fr2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement de ton équipement.`)
};

const de_de2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern deiner Ausstattung ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_equipment = /** @type {(inputs: Onboarding_Failed_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava la tua attrezzatura.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving your equipment." |
*
* @param {Onboarding_Failed_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_equipment = /** @type {((inputs?: Onboarding_Failed_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_equipment(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_equipment(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_equipment(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_equipment(inputs)
	return en_us2_onboarding_failed_equipment(inputs)
});
export { onboarding_failed_equipment as "onboarding.failed_equipment" }